module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_06@2x-bc7d5b01d048c4dd7a458a5aa1107bea.webp";